<script setup lang="js">
import { cn } from '@/lib/utils'
import {
  PopoverContent,
  PopoverPortal,
  useForwardPropsEmits,
} from 'reka-ui'
import { computed } from 'vue'

defineOptions({
  inheritAttrs: false,
})

// define props with default values
const props = defineProps({
  align: {
    type: String,
    default: 'end',
  },
  sideOffset: {
    type: Number,
    default: 16,
  },
  class: [String, Array, Object],
})

// define emits (no type info in JS, just use names)
const emits = defineEmits([
  'escapeKeyDown',
  'interactOutside',
  'pointerDownOutside',
  'focusOutside',
  'closeAutoFocus',
])

// remove `class` before forwarding
const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props
  return delegated
})

// forward props and emits
const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <PopoverPortal>
    <PopoverContent
      v-bind="{ ...forwarded, ...$attrs }"
      :class="
        cn(
          'vf-z-[9999] vf-w-72 vf-rounded-md vf-border vf-bg-popover vf-p-4 text-popover-foreground vf-shadow-md vf-outline-none',
          'data-[state=open]:vf-animate-in data-[state=closed]:vf-animate-out data-[state=closed]:vf-fade-out-0',
          'data-[state=open]:vf-fade-in-0 data-[state=closed]:vf-zoom-out-95 data-[state=open]:vf-zoom-in-95 data-[side=bottom]:vf-slide-in-from-top-2',
          'data-[side=left]:vf-slide-in-from-right-2 data-[side=right]:vf-slide-in-from-left-2 data-[side=top]:vf-slide-in-from-bottom-2',
          props.class
        )
      "
    >
      <slot />
    </PopoverContent>
  </PopoverPortal>
</template>
